import { useQuery } from 'react-query';

import { Metrics } from '@features/enterpriseMetrics';
import { getMetricsRoute } from '@features/enterpriseMetrics/api/constants';
import axiosInstance from '@server/axiosInstance';

type UseGetMetricsData = {
  status: number;
  message: string;
  company_count?: number;
  object: Metrics;
  companies?: any[]
  metrics: any
};
type useGetMetricsProps = {
  selectedCompanyId: string | number;
  enterprise_id?: number

};

export const useGetMetrics = ({
  selectedCompanyId,
  enterprise_id
}: useGetMetricsProps) => {

  const metricsKey = 'metrics';

  const { data: metricsData, isLoading: isLoadingMetrics } =
    useQuery<UseGetMetricsData>([metricsKey, selectedCompanyId], {
      enabled: Boolean(enterprise_id),
      queryFn: () =>
        axiosInstance
          .get(getMetricsRoute, {
            params: { company: selectedCompanyId },
          })
          .then((res) => res.data),
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      staleTime: 1000 * 60 * 10,
      cacheTime: 1000 * 60 * 30,
    });

  return {
    metricsData,
    isLoadingMetrics,
  };
};
